/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type HideViewedFilterSchemaScope = typeof HideViewedFilterSchemaScope[keyof typeof HideViewedFilterSchemaScope];


export const HideViewedFilterSchemaScope = {
  none: 'none',
  org: 'org',
  project: 'project',
  search: 'search',
} as const;
